import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { BarcodeScanner } from '../components/BarcodeScanner';
import { apiFetch } from '../utils/api';
import './ScanScreen.css';

type Mode = 'choice' | 'barcode' | 'result';

interface ScanResult {
  hit: boolean;
  ean: string;
  wine?: any;
}

export function ScanScreen() {
  const navigate = useNavigate();
  const [mode, setMode] = useState<Mode>('choice');
  const [result, setResult] = useState<ScanResult | null>(null);
  const [loading, setLoading] = useState(false);

  const handleBarcodeScan = async (code: string) => {
    setMode('result');
    setLoading(true);
    try {
      const res = await apiFetch(`/cave/wines/by-barcode/${encodeURIComponent(code)}`, { auth: false });
      const data = await res.json();
      setResult(data);
    } catch {
      setResult({ hit: false, ean: code });
    }
    setLoading(false);
  };

  // Mode scanner
  if (mode === 'barcode') {
    return (
      <BarcodeScanner
        onScan={handleBarcodeScan}
        onClose={() => setMode('choice')}
      />
    );
  }

  // Résultat
  if (mode === 'result') {
    return (
      <div className="scan-page scan-center">
        <div className="scan-header">
          <button onClick={() => setMode('choice')}>‹</button>
          <span>Resultat</span>
          <div style={{ width: 24 }} />
        </div>

        {loading ? (
          <p className="scan-loading">Recherche...</p>
        ) : result?.hit && result.wine ? (
          <div className="scan-found">
            <div className="scan-found-icon">✓</div>
            <h2>{result.wine.name}</h2>
            {result.wine.producer && <p className="scan-found-producer">{result.wine.producer}</p>}
            <p className="scan-found-ean">EAN: {result.ean}</p>
            <button className="scan-cta" onClick={() => navigate(`/cave/${result.wine.id}`)}>
              Voir la fiche
            </button>
            <button className="scan-secondary" onClick={() => setMode('choice')}>
              Nouveau scan
            </button>
          </div>
        ) : (
          <div className="scan-notfound">
            <div className="scan-notfound-icon">?</div>
            <h2>Vin non reconnu</h2>
            <p className="scan-found-ean">EAN: {result?.ean}</p>
            <p className="scan-notfound-hint">Ce code-barres n'est pas encore dans notre base.</p>
            <button className="scan-cta" onClick={() => setMode('choice')}>
              Reessayer
            </button>
          </div>
        )}
      </div>
    );
  }

  // Choix du mode de scan
  return (
    <div className="scan-page">
      <div className="scan-header">
        <button onClick={() => navigate(-1)}>‹</button>
        <span>Scanner</span>
        <div style={{ width: 24 }} />
      </div>

      <div className="scan-choices">
        <button className="scan-choice" onClick={() => setMode('barcode')}>
          <span className="scan-choice-icon">📷</span>
          <strong>Scanner un code-barres</strong>
          <span>Identifiez un vin par son code EAN</span>
        </button>

        <button className="scan-choice disabled">
          <span className="scan-choice-icon">🏷</span>
          <strong>Scanner une etiquette</strong>
          <span>Identification par photo (bientot)</span>
        </button>
      </div>
    </div>
  );
}
